import { IconButton, Typography } from '@mui/material';
import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined';
import { useNavigate } from 'react-router-dom';
import { Unit } from '../../models/unit';
import { GridCountCell } from '../../components/grid-cell-count';
import { useAuthorize } from '../../hooks/use-authorize';
import { UserPermissionName } from '../../models/user-permission-name';

interface CustomGridCellProps {
  field: string;
  customerID?: number;
}

interface CellProps {
  unit: Unit;
  customerID?: number;
}

const styling = {
  iconStyle: { color: '$primary-color' },
  textStyle: { paddingLeft: '5px', color: '$primary-color' },
};

const WorkOrdersCountCell = ({ unit }: CellProps) => {
  const isWorkOrderViewPermission = useAuthorize([UserPermissionName.VIEW_WORKORDER]);
  return (
    <GridCountCell
      count={unit.workOrderCount}
      isDisabled={!isWorkOrderViewPermission || unit.isCompleted}
      icon={<HomeWorkOutlinedIcon style={styling.iconStyle} />}
      route={`/workorders?customerID=${unit.customerID}&officeID=${unit.officeID}&projectID=${unit.projectID}&unitID=${unit.unitID}`}
    />
  );
};

export const UnitsCustomGridCell = ({ field }: CustomGridCellProps) => {
  if (field === 'workOrderCount') {
    return (dataItem: any) => {
      return <WorkOrdersCountCell unit={dataItem.dataItem} />;
    };
  }
};
